import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log("Question form controller connected")
  }

  toggle() {
    this.formTarget.classList.toggle("hidden")
  }
}
